import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WorkflowStatus } from "../../utilities/interfaces/WorkflowStatus";
import { workflowStatusApi } from "../../utilities/api/workflowStatusApi";

interface workflowStatusState {
  statuses: WorkflowStatus[];
  status: WorkflowStatus | null;
}

const initialState: workflowStatusState = {
  statuses: [],
  status: null,
}

const workflowStatusSlice = createSlice({
  name: 'stateWorkflowStatus',
  initialState,
  reducers: {

  },
  extraReducers(builder) {
    builder.addCase(getAllWorkflowStatuses.fulfilled, (state, action: any) => {
      state.statuses = action.payload;
    });
    builder.addCase(getWorkflowStatusById.fulfilled, (state, action: any) => {
      state.status = action.payload;
    });
    builder.addCase(getWorkflowStatusByActionId.fulfilled, (state, action: any) => {
      state.statuses = action.payload;
    });
  }
});

export const getAllWorkflowStatuses = createAsyncThunk('stateWorkflowStatus/getAllWorkflowStatuses', async () => {
  const response = await workflowStatusApi.getAll();
  return response;
});

export const getWorkflowStatusById = createAsyncThunk('stateWorkflowStatus/getWorkflowStatusById', async (id: number) => {
  const response = await workflowStatusApi.getById(id);
  return response;
});

export const getWorkflowStatusByActionId = createAsyncThunk('stateWorkflowStatus/getWorkflowStatusByActionId', async (id: number) => {
  const response = await workflowStatusApi.getByActionId(id);
  return response;
});

export default workflowStatusSlice.reducer;